(function () {
  function bindShop(root) {
    if (!root || root.dataset.ipBound === 'true') return;
    root.dataset.ipBound = 'true';

    var promo = root.querySelector('[data-ip-promo]');
    var rows = root.querySelectorAll('[data-ip-model]');
    var panels = root.querySelectorAll('[data-ip-parts-panel]');
    var partsLabel = root.querySelector('[data-ip-parts-label]');
    var partsMore = root.querySelector('[data-ip-parts-more]');
    var partsMoreLabel = root.querySelector('[data-ip-parts-more-label]');
    if (!rows.length) return;

    var rails = root.querySelectorAll('[data-ip-rail]');
    var discoverLinks = root.querySelectorAll('[data-ip-discover]');
    var row3in1 = root.querySelector('[data-ip-model-id="3in1"]');

    var img = promo ? promo.querySelector('[data-ip-promo-img]') : null;
    var brand = promo ? promo.querySelector('[data-ip-promo-brand]') : null;
    var model = promo ? promo.querySelector('[data-ip-promo-model]') : null;
    var tag = promo ? promo.querySelector('[data-ip-promo-tag]') : null;
    var cta = promo ? promo.querySelector('[data-ip-promo-cta]') : null;

    function showRail(name) {
      if (promo) promo.hidden = Boolean(name);
      rails.forEach(function (rail) {
        rail.hidden = rail.getAttribute('data-ip-rail') !== name;
      });
      discoverLinks.forEach(function (link) {
        link.classList.toggle('is-active', Boolean(name) && link.getAttribute('data-ip-discover') === name);
      });
    }

    function showPromo() {
      showRail('');
      if (promo) promo.hidden = false;
    }

    function rowPath(row) {
      var href = row.getAttribute('href') || row.dataset.href || '';
      if (!href) return '';
      try {
        return new URL(href, window.location.origin).pathname.replace(/\/$/, '');
      } catch (err) {
        return href.replace(/\/$/, '');
      }
    }

    function remember(row) {
      var id = row.getAttribute('data-ip-model-id');
      if (!id) return;
      try {
        sessionStorage.setItem('ip-mega-model', id);
      } catch (err) {}
    }

    function initialRow() {
      var pageModel = root.getAttribute('data-ip-page-model');
      if (pageModel) {
        var byPage = root.querySelector('[data-ip-model-id="' + pageModel + '"]');
        if (byPage) return byPage;
      }
      var here = window.location.pathname.replace(/\/$/, '');
      var matched = null;
      rows.forEach(function (row) {
        if (matched) return;
        var path = rowPath(row);
        if (path && (here === path || here.indexOf(path + '/') === 0)) matched = row;
      });
      if (matched) return matched;
      try {
        var saved = sessionStorage.getItem('ip-mega-model');
        if (saved) {
          var found = root.querySelector('[data-ip-model-id="' + saved + '"]');
          if (found) return found;
        }
      } catch (err) {}
      return root.querySelector('[data-ip-model].is-active') || rows[0];
    }

    function activate(row) {
      if (!row) return;
      rows.forEach(function (item) {
        item.classList.toggle('is-active', item === row);
      });

      var modelId = row.getAttribute('data-ip-model-id');
      panels.forEach(function (panel) {
        panel.hidden = panel.getAttribute('data-ip-parts-panel') !== modelId;
      });

      if (partsLabel) partsLabel.textContent = row.dataset.partsLabel || '';
      if (partsMore && row.dataset.moreHref) partsMore.setAttribute('href', row.dataset.moreHref);
      if (partsMoreLabel) partsMoreLabel.textContent = row.dataset.moreLabel || 'Explore parts';
      remember(row);

      if (img && row.dataset.img) {
        img.src = row.dataset.img;
        img.alt = ((row.dataset.brand || '') + ' ' + (row.dataset.model || '')).trim();
      }
      if (brand) brand.textContent = row.dataset.brand || '';
      if (model) model.textContent = row.dataset.model || '';
      if (tag) tag.textContent = row.dataset.tag || '';
      if (cta) cta.textContent = row.dataset.cta || '';

      if (promo) {
        promo.setAttribute('href', row.dataset.href || '#');
        promo.removeAttribute('aria-disabled');
        promo.classList.remove('is-soon');
      }
      showPromo();
    }

    var hoverTimer;
    rows.forEach(function (row) {
      row.addEventListener('pointerenter', function () {
        clearTimeout(hoverTimer);
        hoverTimer = setTimeout(function () {
          activate(row);
        }, 80);
      });
      row.addEventListener('pointerleave', function () {
        clearTimeout(hoverTimer);
      });
      row.addEventListener('focus', function () {
        clearTimeout(hoverTimer);
        activate(row);
      });
    });

    activate(initialRow());

    discoverLinks.forEach(function (link) {
      var kind = link.getAttribute('data-ip-discover');
      link.addEventListener('pointerenter', function () {
        if (kind === 'new' || kind === 'best' || kind === 'contact' || kind === 'ship' || kind === 'guides') {
          showRail(kind);
          return;
        }
        if (kind === 'accessories' && row3in1) {
          activate(row3in1);
          return;
        }
        showPromo();
      });
      link.addEventListener('focus', function () {
        if (kind === 'new' || kind === 'best' || kind === 'contact' || kind === 'ship' || kind === 'guides') {
          showRail(kind);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.ip-mega-shop').forEach(bindShop);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
